import * as t from "io-ts";
import nullable from "./nullable";
import { isoDateTime } from "./date-time";
export const timeTrackingEventT = t.type({
    routeId: t.string,
    truckId: t.string,
    stopId: t.string,
    time: isoDateTime,
    position: nullable(t.strict({
        lat: t.number,
        lon: t.number,
        accuracy: t.number,
    })),
});
//# sourceMappingURL=driver-time-tracking.js.map